import React, {useEffect, useState} from "react";
import {Formik} from "formik";
import {BusinessFormInformationValidation} from "../AddBusinessValidation";
import {InputField, Button} from "components";
import {SectionsProps} from 'models';


export const InformationSection: React.FC<SectionsProps> = ({
                                                                setSectionName,
                                                                changeStep,
                                                                setNewBusinessInfo,
                                                                newBusinessInfo
                                                            }) => {
        useEffect(() => {
            setSectionName('Business Information')
        }, [setSectionName]);

        const [initialValues] = useState({
            information: newBusinessInfo?.information
        });

        const onSubmit = async (values: any, {setSubmitting}: any) => {
            setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({...prevInfo, information: values.information}))

            changeStep && changeStep("next")
            setSubmitting(false);
        }

        return (
            <div className={'add-business-section'}>
                <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                    printing and typesetting industry. </p>
                <Formik
                    validateOnMount={false}
                    validateOnChange={true}
                    initialValues={initialValues}
                    validationSchema={BusinessFormInformationValidation}
                    onSubmit={onSubmit}
                >
                    {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                        <form onSubmit={handleSubmit}>
                            <div className={'add-business-section_input'}>
                                <InputField
                                    id={"information.title"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Your Title/position"}
                                    name="information.title"
                                    onblur={handleBlur}
                                    error={errors.information?.title && touched.information?.title}
                                    onchange={handleChange}
                                    message={errors.information?.title && touched.information?.title && errors.information?.title}
                                    inputValue={values.information?.title}
                                    label={'Your Business Title'}
                                />
                            </div>
                            <div className={'add-business-section_input'}>
                                <InputField
                                    id={"information.name"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Business Name"}
                                    name="information.name"
                                    onblur={handleBlur}
                                    error={errors.information?.name && touched.information?.name}
                                    onchange={handleChange}
                                    message={errors.information?.name && touched.information?.name && errors.information?.name}
                                    inputValue={values.information?.name}
                                    label={'Business Name'}
                                />
                                <InputField
                                    id={"information.address"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Business Address"}
                                    name="information.address"
                                    onblur={handleBlur}
                                    error={errors.information?.address && touched.information?.address}
                                    onchange={handleChange}
                                    message={errors.information?.address && touched.information?.address && errors.information?.address}
                                    inputValue={values.information?.address}
                                    label={'Business Address'}
                                />
                                <InputField
                                    id={"information.contact"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Business Contact"}
                                    name="information.contact"
                                    onblur={handleBlur}
                                    error={errors.information?.contact && touched.information?.contact}
                                    onchange={handleChange}
                                    message={errors.information?.contact && touched.information?.contact && errors.information?.contact}
                                    inputValue={values.information?.contact}
                                    label={'Business Contact'}
                                />
                                <InputField
                                    id={"information.email"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Eg: 'example@gmail.com'"}
                                    name="information.email"
                                    onblur={handleBlur}
                                    error={errors.information?.email && touched.information?.email}
                                    onchange={handleChange}
                                    message={errors.information?.email && touched.information?.email && errors.information?.email}
                                    inputValue={values.information?.email}
                                    label={'Business Email'}
                                />
                                <InputField
                                    id={"information.website"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Business Website"}
                                    name="information.website"
                                    onblur={handleBlur}
                                    error={errors.information?.website && touched.information?.website}
                                    onchange={handleChange}
                                    message={errors.information?.website && touched.information?.website && errors.information?.website}
                                    inputValue={values.information?.website}
                                    label={'Business Website'}
                                />
                            </div>
                            <div className={'add-business-section_cta'}>
                                <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                                <Button type={"primary"} isSubmit={true} text={"Next"}/>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        );
    }
;
